import React from "react";
import { Card, Grid, Stack, Box, useTheme, useMediaQuery } from "@mui/material";
import TitleSectionComponent from "../../../../components/core-components/titleSection";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MailIcon from "@mui/icons-material/Mail";
import { ContactService } from "../../../../network/ContactService";
import { useQuery } from "@tanstack/react-query";

function Contact() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const contactService = new ContactService();

  const { data } = useQuery({
    queryKey: ["contact"],
    queryFn: async () => {
      const res = await contactService.getAll();
      return res?.data;
    },
  });

  const contactInfo = [
    {
      icon: (
        <PhoneIcon
          sx={{
            width: "24px",
            height: "24px",
          }}
        />
      ),
      text: data?.phone,
      onClick: () => {
        window.location.href = `tel:${data?.phone}`;
      },
    },
    {
      icon: (
        <MailIcon
          sx={{
            width: "24px",
            height: "24px",
          }}
        />
      ),
      text: data?.email,
      onClick: () => {
        window.location.href = `mailto:${data?.email}`;
      },
    },
    {
      icon: (
        <WhatsAppIcon
          sx={{
            width: "24px",
            height: "24px",
          }}
        />
      ),
      text: data?.whatsapp,
      onClick: () => {
        window.location.href = `https://wa.me/${data?.whatsapp}`;
      },
    },
    {
      icon: (
        <LocationOnIcon
          sx={{
            width: "24px",
            height: "24px",
          }}
        />
      ),
      text: data?.address,
      onClick: () => {
        window.open(`https://www.google.com/maps?q=${data?.address}`, "_blank");
      },
    },
    {
      icon: (
        <AccessTimeIcon
          sx={{
            width: "24px",
            height: "24px",
          }}
        />
      ),
      text: "Pazartesi - Cuma: 09:00 - 17:00",
    },
  ];

  return (
    <section
      id="contact"
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        paddingTop: "40px",
        paddingBottom: "40px",
      }}
    >
      <div className="container">
        <TitleSectionComponent titleText="İletişim" />
        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid 
            item 
            xs={12} 
            md={5} 
            sx={{ 
              order: {
                xs: 2,
                sm: 2,
                md: 1
              }
            }}
          >
            <Grid container direction="column" spacing={2}>
              {contactInfo.map((info, index) => (
                <Grid item xs={12} key={index}>
                  <Card
                    onClick={info.onClick}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      transition: "box-shadow 0.3s",
                      "&:hover": info.onClick ? {
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                      } : {},
                      height: "auto",
                      minHeight: "60px",
                      display: "flex",
                      alignItems: "center",
                      padding: "16px",
                      cursor: info.onClick ? "pointer" : "default",
                      width: "100%",
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="center"
                      sx={{ width: "100%" }}
                    >
                      {info.icon}
                      <span style={{ 
                        fontSize: "16px",
                        color: "#000",
                      }}>
                        {info.text}
                      </span>
                    </Stack>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid 
            item 
            xs={12} 
            md={7} 
            sx={{ 
              order: {
                xs: 1,
                sm: 1,
                md: 2
              },
              mb: { xs: 3, sm: 3, md: 0 }
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: { xs: "300px", sm: "400px", md: "400px" },
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              
              <iframe
                title="Google Maps"
                src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Dikilita%C5%9F,%20Beste%20Sokak%20No:5,%20Be%C5%9Fikta%C5%9F/%C4%B0stanbul+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                 
                width="100%"
                height="100%"
                style={{
                  border: 0,
                }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              {/*
              <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d24094.51754534292!2d29.093906423270337!3d40.98553836660565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sAtat%C3%BCrk%20Mah.%20Ertu%C4%9Frul%20Gazi%20Sok.%20METROPOL%20%C4%B0STANBUL%20No%3A%202E%2C%20A%20Blok%20Daire%3A452%20%20%2034758%20%20Ata%C5%9Fehir%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1741629898862!5m2!1str!2str"   
                 title="Google Maps"
                width="100%"
                height="100%"
                style={{
                  border: 0,
                }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
             />
              */}
            </Box>
          </Grid>
        </Grid>
      </div>
    </section>
  );
}

export default Contact;